import React from 'react';
import styled from 'styled-components';
import { useAppDispatch } from '../../store';
import PrivacyPolicy from '../common/popup/PrivacyPolicy';
import { showPrivacy } from '../common/popup/popupSlice';
import { logos } from '../sections/renewalAssets';
import { company } from '../sections/renewalData';
import { buttonReset, token } from '../sections/renewalStyles';

const FooterWrap = styled.footer`
  background: #000;
  color: ${token.faint};
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  padding: 56px 32px;

  @media screen and (max-width: 768px) {
    padding: 40px 20px;
  }
`;

const FooterInner = styled.div`
  max-width: ${token.maxWidth};
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  align-items: center;
  justify-content: space-between;
`;

const FooterLogo = styled.img`
  height: 34px;
  width: auto;
  display: block;
`;

const FooterBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  align-items: flex-start;
`;

const LinkRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: center;
`;

const PrivacyButton = styled.button`
  ${buttonReset};
  color: #fff;
  font-size: 14px;
  font-weight: 700;
`;

const FooterLink = styled.a`
  font-size: 14px;
  color: ${token.faint};

  &:hover {
    color: #fff;
  }
`;

const FooterInfo = styled.p`
  margin: 0;
  font-size: 13px;
  line-height: 1.8;
`;

export default function Footer() {
  const dispatch = useAppDispatch();

  const onClickPrivacy = () => dispatch(showPrivacy());

  return (
    <FooterWrap>
      <FooterInner>
        <FooterLogo src={logos.footer} alt="BRIT" width="112" height="34" />
        <FooterBody>
          <LinkRow>
            <PrivacyButton type="button" onClick={onClickPrivacy}>
              개인정보처리방침
            </PrivacyButton>
            <FooterLink href={company.site} target="_blank" rel="noopener noreferrer">
              {company.siteLabel}
            </FooterLink>
            <FooterLink href={company.saramin} target="_blank" rel="noopener noreferrer">
              진행중인 채용공고
            </FooterLink>
          </LinkRow>
          <FooterInfo>
            {company.name} · 대표이사 {company.ceo}
            <br />
            본점 {company.headOffice}
            <br />
            지점 {company.branch}
            <br />© 2026 BRIT. All rights reserved.
          </FooterInfo>
        </FooterBody>
      </FooterInner>
      <PrivacyPolicy />
    </FooterWrap>
  );
}
